import { Routes, Route, Navigate } from 'react-router-dom'
import { AppLayout } from '@/components/layout/AppLayout'
import { LandingPage } from '@/pages/LandingPage'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { ChatPage } from '@/pages/ChatPage'
import { ManualsPage } from '@/pages/ManualsPage'
import { PredictiveMaintenancePage } from '@/pages/PredictiveMaintenancePage'
import { TroubleshootingPage } from '@/pages/TroubleshootingPage'
import { AircraftHistoryPage } from '@/pages/AircraftHistoryPage'
import { UsersPage } from '@/pages/admin/UsersPage'
import { AnalyticsPage } from '@/pages/admin/AnalyticsPage'
import { AuditLogPage } from '@/pages/admin/AuditLogPage'
import { MaintenanceProgramPage } from '@/pages/MaintenanceProgramPage'
import { SearchPage } from '@/pages/SearchPage'
import { ConnectedSourcesPage } from '@/pages/admin/ConnectedSourcesPage'
import { CampIntegrationPage } from '@/pages/admin/CampIntegrationPage'
import { ServiceCentersPage } from '@/pages/admin/ServiceCentersPage'

function RequireAuth({ children }: { children: React.ReactElement }) {
  const token = localStorage.getItem('voltaire_token')
  if (!token) {
    return <Navigate to="/login" replace />
  }
  return children
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* App routes (authenticated) */}
      <Route path="/app" element={<RequireAuth><AppLayout /></RequireAuth>}>
        <Route index element={<DashboardPage />} />
        <Route path="chat" element={<ChatPage />} />
        <Route path="predictive" element={<PredictiveMaintenancePage />} />
        <Route path="maintenance-program" element={<MaintenanceProgramPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="troubleshooting" element={<TroubleshootingPage />} />
        <Route path="aircraft-history" element={<AircraftHistoryPage />} />
        <Route path="manuals" element={<ManualsPage />} />

        {/* Admin routes */}
        <Route path="admin/users" element={<UsersPage />} />
        <Route path="admin/analytics" element={<AnalyticsPage />} />
        <Route path="admin/audit" element={<AuditLogPage />} />
        <Route path="admin/connected-sources" element={<ConnectedSourcesPage />} />
        <Route path="admin/camp-integration" element={<CampIntegrationPage />} />
        <Route path="admin/service-centers" element={<ServiceCentersPage />} />

        {/* Placeholder routes */}
        <Route path="settings" element={<PlaceholderPage title="Settings" />} />
        <Route path="settings/profile" element={<PlaceholderPage title="Profile Settings" />} />
        <Route path="help" element={<PlaceholderPage title="Help & Support" />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

function PlaceholderPage({ title }: { title: string }) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        <p className="mt-2 text-gray-600">This page is under construction.</p>
      </div>
    </div>
  )
}

export default App
